import './App.css';
import CalcBody from './components/CalcBody';

function App() {
  return (
    <>
      < CalcBody />
    </>
  );
}

export default App;
